import { render, staticRenderFns } from "./detial.vue?vue&type=template&id=02ce0cfc&scoped=true&"
import script from "./detial.vue?vue&type=script&lang=js&"
export * from "./detial.vue?vue&type=script&lang=js&"
import style0 from "./detial.vue?vue&type=style&index=0&id=02ce0cfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ce0cfc",
  null
  
)

export default component.exports